import Checkbox from '@standardsdigital/ui-components/Checkbox';
import Label from '@standardsdigital/ui-components/Label';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';
import styles from '../ServiceLevelForm.module.css';

interface BooleanCheckboxesProps {
  draftStandards: boolean;
  redline: boolean;
  multiLanguage: boolean;
  onDraftStandardsChange: (checked: boolean) => void;
  onRedlineChange: (checked: boolean) => void;
  onMultiLanguageChange: (checked: boolean) => void;
  isDirty: boolean;
  disabled: boolean;
}

function BooleanCheckboxes({
  draftStandards,
  redline,
  multiLanguage,
  onDraftStandardsChange,
  onRedlineChange,
  onMultiLanguageChange,
  isDirty,
  disabled,
}: Readonly<BooleanCheckboxesProps>) {
  const { t } = useTranslation();

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <div className={styles.booleanFields}>
        <Label as="legend">{t('serviceLevels.form.agreementServices')}</Label>
        <Checkbox
          label={t('serviceLevels.form.draftStandards')}
          checked={draftStandards}
          onCheckedChange={(checked) => onDraftStandardsChange(Boolean(checked))}
          disabled={disabled}
        />
        <Checkbox
          label={t('serviceLevels.form.redline')}
          checked={redline}
          onCheckedChange={(checked) => onRedlineChange(Boolean(checked))}
          disabled={disabled}
        />
        <Checkbox
          label={t('serviceLevels.form.multiLanguage')}
          checked={multiLanguage}
          onCheckedChange={(checked) => onMultiLanguageChange(Boolean(checked))}
          disabled={disabled}
        />
      </div>
    </FieldStatusWrapper>
  );
}

export default BooleanCheckboxes;
